<template>
  <DataTable
    :value="files"
    :scrollable="$isLargeScreen.value"
    responsiveLayout="stack"
  >
    <Column
      header="Nome"
      field="file.name"
      :sortable="true"
      style="min-width: 170px"
    >
      <template #body="{ data }">
        <a
          v-if="isImage(data.file.url)"
          @click="openDialog(data.file)"
          href="#"
        >
          {{ data.file.name || '-' }}
        </a>
        <a
          v-else
          :href="data.file.url"
          :download="data.file.name"
          target="'_self'"
        >
          {{ data.file.name || '-' }}
        </a>
      </template>
    </Column>
    <Column
      header="Data"
      field="file.createdAt"
      :sortable="true"
      style="max-width: 100px"
    >
      <template #body="{ data }">
        {{ $formatDate(data.file.createdAt) }}
      </template>
    </Column>
    <Column header="Ações">
      <template #body="{ data }">
        <a
          :href="data.file.url"
          :download="data.file.name"
          :target="isImage(data.file.url) ? '_blank' : '_self'"
        >
          <Button
            type="button"
            icon="pi pi-download"
            class="p-button-text p-button-secondary"
          ></Button>
        </a>
        <Button
          :disabled="data.default"
          type="button"
          icon="pi pi-trash"
          class="p-button-text p-button-secondary"
          @click="$emit('remove', data.fileId || data.id)"
        ></Button>
      </template>
    </Column>
  </DataTable>
  <Dialog
    v-model:visible="dialogVisible"
    :header="dialogFile?.name"
    :modal="true"
    :closable="true"
    :dismissableMask="true"
  >
    <img
      :src="dialogFile.url"
      style="object-fit: cover; max-width: 80vw; max-heigth: 80vw"
    />
    <template #footer>
      <Button
        label="Fechar"
        class="p-button-secondary"
        @click="closeDialog()"
      />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: 'FileDataTable',
  props: {
    files: Array,
  },
  emits: ['remove'],
  data() {
    return {
      dialogFile: null,
      dialogVisible: false,
    };
  },
  methods: {
    isImage(url) {
      return url.match(/\.(jpeg|jpg|gif|png)/) != null;
    },
    openDialog(file) {
      this.dialogFile = file;
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.dialogFile = null;
    },
  },
};
</script>

<style>
</style>